import { render, staticRenderFns } from "./rewardCard.vue?vue&type=template&id=bf2f9388&scoped=true&"
import script from "./rewardCard.vue?vue&type=script&lang=js&"
export * from "./rewardCard.vue?vue&type=script&lang=js&"
import style0 from "./rewardCard.vue?vue&type=style&index=0&id=bf2f9388&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2f9388",
  null
  
)

export default component.exports